export default ({ post, patch, checkStatus, toJSON }) => ({
  createActivitySession: (body) =>
    post("universe/v1/activity_sessions", { body })
      .then(checkStatus)
      .then(toJSON),
  updateActivitySession: (id, body) =>
    patch(`universe/v1/activity_sessions/${id}`, { body })
      .then(checkStatus)
      .then(toJSON),
});
